module.exports = __webpack_public_path__ + "img/Banner-Test.a37d8c2c.webp";